import * as React from 'react';
import { Button, StyleRulesCallback, Theme, withStyles, WithStyles } from '@material-ui/core';
import { InjectedFormProps, reduxForm } from 'redux-form';
import { AssistantData, HuesgesData } from '../../../model/inspectionData';
import HuesgesVehicleFormData from './HuesgesVehicleFormData';
import HuesgesAlternativeInspectionPlaceFormData from './HuesgesAlternativeInspectionPlaceFormData';
import { Redirect } from 'react-router';
import HuesgesContactFormData from './HuesgesContactFormData';

type CssClasses = 'formContainer' | 'submit';
const styles: StyleRulesCallback<CssClasses> = (theme: Theme) => ({
  formContainer: {
    paddingTop: theme.spacing.unit * 4,
  },
  submit: {
    position: 'absolute',
    right: '0px',
    bottom: '0px',
  },
});

interface OwnProps {
  initalData: AssistantData | null;
  inspectionId: string;
  onSubmitHandler: (values: HuesgesData) => Promise<any>;
}

interface State {
  redirect: false;
}

type Props = OwnProps & WithStyles<CssClasses> & InjectedFormProps<HuesgesData, OwnProps>;

class HuesgesForm extends React.Component<Props> {
  state = {
    redirect: false,
  };

  public componentDidUpdate(oldProps: Props) {
    const newProps: Props = this.props;
    // if (oldProps.initalData == null && newProps.initalData != null) {
    //   const initalData = newProps.initalData as AssistantData;
    //   this.props.change('mail', initalData.mail);
    // } else {
    //   if (newProps.initalData != null) {
    //     const { log } = console;
    //     log('blup');
    //     this.props.change('phoneNumber', newProps.initalData.phoneNumber);
    //     this.props.change('mail', newProps.initalData.mail);
    //     this.props.change('vehicleManufacturer', newProps.initalData.vehicleManufacturer);
    //     this.props.change('vehicleModel', newProps.initalData.vehicleModel);
    //     this.props.change('zipCode', newProps.initalData.zipCode);
    //   } else {
    //     this.props.change('phoneNumber', '');
    //     this.props.change('mail', '');
    //     this.props.change('vehicleManufacturer', '');
    //     this.props.change('vehicleModel', '');
    //   }
    // }
  }

  render() {
    const { classes, handleSubmit, onSubmitHandler } = this.props;
    const { redirect } = this.state;

    if (redirect) {
      return <Redirect to={'/success'} />;
    }

    return (
      <form onSubmit={handleSubmit(onSubmitHandler)}>
        <div className={classes.formContainer}>
          <HuesgesContactFormData />
        </div>
        <div className={classes.formContainer}>
          <HuesgesAlternativeInspectionPlaceFormData />
        </div>
        <div className={classes.formContainer}>
          <HuesgesVehicleFormData />
        </div>
        <div style={{ position: 'relative', height: '80px' }}>
          <Button variant={'contained'} color={'primary'} className={classes.submit} type={'submit'}>
            Senden
          </Button>
        </div>
      </form>
    );
  }
}

export default reduxForm<HuesgesData, OwnProps>({ form: 'huesges' })(withStyles(styles)(HuesgesForm));



// WEBPACK FOOTER //
// ./src/routes/inspection/container/HuesgesForm.tsx